module.exports = __webpack_public_path__ + "img/filter-type-warmup--active.70c97c7d.svg";